
export const fetchFromPort = async (endpoint) => {
    const PORT = 17432;
    try {
        const response = await fetch(
            `http://localhost:${PORT}${endpoint}`
        );
        return { response };
    } catch (error) {
        throw error;
    }
};

export const checkForNFCAvailability = async () => {
    let statusResponse;
    try {
        const result = await fetchFromPort('/status');
        statusResponse = result.response;
    } catch (error) {
        alert(
            'Unable to connect to NFC service. Please ensure the NFC service is running.'
        );
        return false;
    }

    const statusData = await statusResponse.json();

    if (!statusData.running || !statusData.ready) {
        alert('NFC service is not running or not ready');
        return false;
    }

    // Check if readers are available
    if (!statusData.readers || statusData.readers.length === 0) {
        alert('NFC card reader not detected');
        return false;
    }

    return true;
};
